import C from "@/components/modal/ModalRow.module.css";

import { cn } from "@/utils/classNames.ts";
import type { ReactNode } from "react";

export function ModalRow({ children, title, ellipsis }: { children: ReactNode; title: string; ellipsis?: boolean }) {
    return (
        <div className={cn("md:flex", C.Row)}>
            <div className={C.Title}>{title}</div>
            <div className={cn(C.Content, ellipsis && C.Ellipsis)}>{children}</div>
        </div>
    );
}
